"use client"
import { Marquee } from "@/app/Components/Marquee"
import { SiTrustpilot } from "react-icons/si"
import Image from "next/image"
import { useTranslations } from "next-intl"

const reviews = [
  {
    name: "Nivedh KING",
    avatar: "https://cdn.aurex.lk/avatars/Kavindu.webp",
    rating: 5,
    title: "Aurex Hosting is Best",
    text: "I am one of the official partners of Aurex Hosting. This is the hosting I was finding for 3 years - sooo cool. The interface and everything is smooth and cool, I have no words. Best hosting I have experienced in my life.",
    country: "IN",
    date: "A day ago",
    obsidian: false
  },
  {
    name: "Sarith Basnayake",
    avatar: "https://cdn.aurex.lk/avatars/Asel.webp",
    rating: 5,
    title: "One of the Best Hosting Platforms",
    text: "I won a giveaway from Aurex and got a server. Honestly, this platform is all good and I personally love the flow. The UI is great, customer support and everything related to them is appreciable. It's just great and I love the experience.",
    country: "LK",
    date: "2 days ago",
    obsidian: false
  },
  {
    name: "ht_nethpot",
    avatar: "https://cdn.aurex.lk/avatars/Sachini.webp",
    rating: 5,
    title: "Really good hosting!",
    text: "MrLord_G (the owner) offered me a free 8 GB RAM server because I am a dev, so I got a server for testing my plugins and it runs perfectly fine and really smooth! I am really happy while using Aurex Hosting.",
    country: "DE",
    date: "May 15, 2026",
    obsidian: false
  },
  {
    name: "DRAK GAMING",
    avatar: "https://cdn.aurex.lk/avatars/Chamara.webp",
    rating: 5,
    title: "Best hosting W",
    text: "Best hosting W.",
    country: "LK",
    date: "May 12, 2026",
    obsidian: false
  },
  {
    name: "vnqz",
    avatar: "https://cdn.aurex.lk/avatars/Malith.webp",
    rating: 5,
    title: "When I first knew about Aurex",
    text: "I made a ticket in their DC because I wanted to make a tierlist and they instantly replied. With Aurex we made the new best tierlist in all of Sri Lanka - Silver Tiers LK. The Aurex team is truly quick and kind, and I got provided with resources immediately. Thank you Aurex so much for partnering with me!",
    country: "LK",
    date: "May 12, 2026",
    obsidian: false
  },
  {
    name: "GaMingTinU",
    avatar: "https://cdn.aurex.lk/avatars/Tharindu.webp",
    rating: 5,
    title: "Actually",
    text: "I came across Aurex by chance while looking for a good host to build my Minecraft network. Their customer service is also very friendly, you should try it out ❤️🤝.",
    country: "LK",
    date: "Apr 24, 2026",
    obsidian: true
  },
  {
    name: "Dulanga Perera",
    avatar: "https://cdn.aurex.lk/avatars/Yasiru.webp",
    rating: 5,
    title: "Supiri customer service",
    text: "Supiri customer service ekak tiyenawa kiyanna wachana na. W AUREX HOSTING.",
    country: "LK",
    date: "May 7, 2026",
    obsidian: false
  },
  {
    name: "IdentifyDelay",
    avatar: "https://cdn.aurex.lk/avatars/Hiruni.webp",
    rating: 5,
    title: "The management has been nothing but kind and helpful",
    text: "I won a giveaway by Aurex Technologies, I opened a ticket to claim them and got the reward straight away without any serious complication or waiting time. Thank you Aurex Technologies! :)",
    country: "IL",
    date: "May 5, 2026",
    obsidian: false
  },
  {
    name: "Roblox Gamer",
    avatar: "https://cdn.aurex.lk/avatars/Ravindu.webp",
    rating: 5,
    title: "Staff Accuracy",
    text: "Very good staff and help to solve problems asap.",
    country: "LK",
    date: "May 1, 2026",
    obsidian: false
  },
  {
    name: "Sathiw Vimash",
    avatar: "https://cdn.aurex.lk/avatars/Dineth.webp",
    rating: 5,
    title: "Nice hosting!",
    text: "Nice hosting!",
    country: "LK",
    date: "Apr 24, 2026",
    obsidian: false
  },
  {
    name: "gaming wonka",
    avatar: "https://cdn.aurex.lk/avatars/Kavindu.webp",
    rating: 5,
    title: "Best customer support and best server hosting",
    text: "Best customer support and best server hosting.",
    country: "LK",
    date: "Apr 18, 2026",
    obsidian: false
  },
  {
    name: "ravering",
    avatar: "https://cdn.aurex.lk/avatars/Asel.webp",
    rating: 5,
    title: "Aurex is a great host!",
    text: "I was offered a server by MrLord (CEO) on December 22nd 2025. Not only did I receive more resources when I asked for them, but the management team has been insanely kind to me. Their new game panel & dashboard just got a revamp and it looks way cleaner. One of the most underrated hosts out there.",
    country: "RO",
    date: "Apr 14, 2026",
    obsidian: true
  },
  {
    name: "Rechi Reiner",
    avatar: "https://cdn.aurex.lk/avatars/Sachini.webp",
    rating: 5,
    title: "Fabulous experience",
    text: "Fabulous experience, seamless and fast support.",
    country: "IN",
    date: "Apr 10, 2026",
    obsidian: false
  },
  {
    name: "Vinuga Nethmira",
    avatar: "https://cdn.aurex.lk/avatars/Chamara.webp",
    rating: 5,
    title: "W AUREX",
    text: "This is literally the best server hosting ever. It gives the best servers for an affordable price. Absolutely GODLY!!!!",
    country: "LK",
    date: "Apr 9, 2026",
    obsidian: false
  },
  {
    name: "Night Mary",
    avatar: "https://cdn.aurex.lk/avatars/Malith.webp",
    rating: 5,
    title: "Great Hosting, Loved It! Quick and Easy",
    text: "This hosting is actually great and cheap. I had an issue with payment related things inside the dashboard and it got fixed within 5 minutes! The server performance is also good. The staff are polite and very knowledgeable. Absolutely recommended hosting.",
    country: "IN",
    date: "Apr 9, 2026",
    obsidian: false
  },
  {
    name: "Udula P. Malalasekara",
    avatar: "https://cdn.aurex.lk/avatars/Yasiru.webp",
    rating: 5,
    title: "Best Hosting Service",
    text: "You guys have a great customer service. I love that.",
    country: "LK",
    date: "Apr 8, 2026",
    obsidian: false
  },
  {
    name: "fetroo",
    avatar: "https://cdn.aurex.lk/avatars/Hiruni.webp",
    rating: 5,
    title: "Aurex on top",
    text: "Best server hosting in Sri Lanka!!",
    country: "LK",
    date: "Apr 8, 2026",
    obsidian: false
  },
  {
    name: "GokuMegaBite",
    avatar: "https://cdn.aurex.lk/avatars/Asel.webp",
    rating: 5,
    title: "The Best Hosting Provider In Sri Lanka!",
    text: "The best hosting provider I have ever come across. The servers are high quality and also 24/7 customer service from the staff! Personally Migrator is my best staff member who is always helping me.",
    country: "LK",
    date: "Apr 5, 2026",
    obsidian: true
  },
  {
    name: "Ruvo MC",
    avatar: "https://cdn.aurex.lk/avatars/Ravindu.webp",
    rating: 5,
    title: "Aurex is the best",
    text: "The ping was so good and no lag.",
    country: "LK",
    date: "Apr 8, 2026",
    obsidian: false
  },
  {
    name: "Vidul Gunawardana",
    avatar: "https://cdn.aurex.lk/avatars/Dineth.webp",
    rating: 5,
    title: "Top hosting in Sri Lanka",
    text: "I've known Aurex Hosting for years. Everyone knows it's top 1 hosting in Sri Lanka - not just right now, always. I bought a Minecraft server and it's running smoothly. W customer service - loving customer, thanks!",
    country: "LK",
    date: "Apr 7, 2026",
    obsidian: false
  },
  {
    name: "Bigdihsteve",
    avatar: "https://cdn.aurex.lk/avatars/Tharindu.webp",
    rating: 5,
    title: "Aurex on top",
    text: "Aurex on top. Best VPN providers and good customer service.",
    country: "LK",
    date: "Apr 6, 2026",
    obsidian: false
  },
  {
    name: "Dithira menul",
    avatar: "https://cdn.aurex.lk/avatars/Kavindu.webp",
    rating: 5,
    title: "Nice Service",
    text: "Nice service. W ping.",
    country: "LK",
    date: "Apr 5, 2026",
    obsidian: false
  },
  {
    name: "Black WiZARD",
    avatar: "https://cdn.aurex.lk/avatars/Sachini.webp",
    rating: 5,
    title: "W hosting service",
    text: "W hosting service and W active staff.",
    country: "LK",
    date: "Apr 5, 2026",
    obsidian: false
  },
  {
    name: "Gamester",
    avatar: "https://cdn.aurex.lk/avatars/Yasiru.webp",
    rating: 5,
    title: "Best hosting service for creators",
    text: "As a content creator, I'm using Aurex hosting services for my videos and so far, it is the best hosting service I have ever used.",
    country: "LK",
    date: "Oct 21, 2025",
    obsidian: true
  },
  {
    name: "Rio Gamer",
    avatar: "https://cdn.aurex.lk/avatars/Chamara.webp",
    rating: 5,
    title: "#1 Aurex",
    text: "The best game host is Aurex.",
    country: "LK",
    date: "Apr 5, 2026",
    obsidian: false
  },
  {
    name: "Abhilash Kumarasinghe",
    avatar: "https://cdn.aurex.lk/avatars/Malith.webp",
    rating: 5,
    title: "Aurex is the Best Hosting",
    text: "Aurex is the best hosting I know for trusted one.",
    country: "LK",
    date: "Apr 5, 2026",
    obsidian: false
  },
  {
    name: "Chenuth Devthisa",
    avatar: "https://cdn.aurex.lk/avatars/Hiruni.webp",
    rating: 5,
    title: "Best hosting service",
    text: "Very good customer service and best hosting service.",
    country: "SG",
    date: "Apr 5, 2026",
    obsidian: false
  },
  {
    name: "Gladeify",
    avatar: "https://cdn.aurex.lk/avatars/Ravindu.webp",
    rating: 5,
    title: "Best hosting service",
    text: "Best hosting service.",
    country: "LK",
    date: "Apr 5, 2026",
    obsidian: false
  },
  {
    name: "Andare Gaming",
    avatar: "https://cdn.aurex.lk/avatars/Dineth.webp",
    rating: 5,
    title: "Customer services are awesome",
    text: "Customer services are awesome.",
    country: "LK",
    date: "Apr 5, 2026",
    obsidian: false
  },
  {
    name: "Sachen DS",
    avatar: "https://cdn.aurex.lk/avatars/Hiruni.webp",
    rating: 5,
    title: "Perfect Minecraft hosting",
    text: "I tried Aurex for my Minecraft server and it works perfectly. No lag, fast setup, and great experience overall.",
    country: "LK",
    date: "Mar 28, 2026",
    obsidian: true
  },
  {
    name: "Janitha Visalka",
    avatar: "https://cdn.aurex.lk/avatars/Tharindu.webp",
    rating: 5,
    title: "Best trusted in Sri Lanka",
    text: "Best trusted in Sri Lanka.",
    country: "LK",
    date: "Apr 5, 2026",
    obsidian: false
  },
  {
    name: "sachintha",
    avatar: "https://cdn.aurex.lk/avatars/Kavindu.webp",
    rating: 5,
    title: "W Hosting man",
    text: "W hosting man! This hosting is a game changer. I hosted my Minecraft server from another host that was too laggy, however Aurex gave me a better server experience! W Aurex.",
    country: "LK",
    date: "Apr 5, 2026",
    obsidian: false
  },
  {
    name: "Nightmare",
    avatar: "https://cdn.aurex.lk/avatars/Asel.webp",
    rating: 5,
    title: "Best Hosting I Ever Used",
    text: "Best hosting I ever used. W Aurex.",
    country: "LK",
    date: "Apr 3, 2026",
    obsidian: false
  },
  {
    name: "Dulain Sathsara",
    avatar: "https://cdn.aurex.lk/avatars/Sachini.webp",
    rating: 5,
    title: "Good customer support",
    text: "Good ah good customer support.",
    country: "LK",
    date: "Apr 3, 2026",
    obsidian: false
  },
  {
    name: "NS SUPER",
    avatar: "https://cdn.aurex.lk/avatars/Chamara.webp",
    rating: 5,
    title: "Very Good Services",
    text: "Definitely trustworthy company. I have been using their services for months now. Very helpful and friendly team. Also I never had downtimes in both VPN and hosting.",
    country: "LK",
    date: "Jul 6, 2025",
    obsidian: false
  },
  {
    name: "GlitcherZ",
    avatar: "https://cdn.aurex.lk/avatars/Ravindu.webp",
    rating: 5,
    title: "One of the best hosting services",
    text: "AUREX is one of the best server hosting services I've ever used. There are no lags and no server issues, and the staff members are very friendly and always ready to help with anything. I personally use AUREX servers for my content. Setting up a server is also very easy and simple.",
    country: "LK",
    date: "Mar 11, 2026",
    obsidian: true
  },
  {
    name: "StaticPvP.fun",
    avatar: "https://cdn.aurex.lk/avatars/Malith.webp",
    rating: 5,
    title: "Outstanding performance with 150+ players",
    text: "Hey, my name is Revenge, owner of StaticPvP.fun. I've run multiple servers over the years, and for this project I decided to give Aurex a try. Even with 150+ concurrent players, the performance has been outstanding - smooth, fast, and consistently stable. Aurex easily stands out as one of the top game server hosts not just in Sri Lanka, but across Asia.",
    country: "LK",
    date: "May 2026",
    obsidian: false
  },
  {
    name: "GʜOꜱT",
    avatar: "https://cdn.aurex.lk/avatars/Kavindu.webp",
    rating: 5,
    title: "Nice hosting",
    text: "Nice hosting mate, I love this.",
    country: "LK",
    date: "Oct 21, 2025",
    obsidian: false
  },
  {
    name: "DR ZIROX",
    avatar: "https://cdn.aurex.lk/avatars/Asel.webp",
    rating: 5,
    title: "Friendly service",
    text: "Friendly service, supirima thamai, highly recommended.",
    country: "LK",
    date: "Oct 21, 2025",
    obsidian: false
  },
  {
    name: "ヴォプジー",
    avatar: "https://cdn.aurex.lk/avatars/Sachini.webp",
    rating: 5,
    title: "User friendly hosting",
    text: "So I can proudly say this is one of the best hosting because the UI is user friendly, 24/7 staff support plus they are friendly too. Recommended.",
    country: "LK",
    date: "Oct 21, 2025",
    obsidian: false
  },
  {
    name: "coolprins308308",
    avatar: "https://cdn.aurex.lk/avatars/Chamara.webp",
    rating: 5,
    title: "Active team",
    text: "Aurex team eka godak active, eken wada godak pahasui.",
    country: "LK",
    date: "Oct 21, 2025",
    obsidian: false
  },
  {
    name: "Filltrix",
    avatar: "https://cdn.aurex.lk/avatars/Dineth.webp",
    rating: 5,
    title: "Excellent uptime and support",
    text: "Excellent uptime and seamless, reliable Minecraft server performance. When help is needed, the support staff is fantastic, quick, and very helpful. Strongly advised for anyone searching for dependable hosting - Aurex Hosting is truly an amazing platform for Minecraft server hosting.",
    country: "LK",
    date: "Mar 11, 2026",
    obsidian: true
  },
  {
    name: "CoOpElite",
    avatar: "https://cdn.aurex.lk/avatars/Malith.webp",
    rating: 5,
    title: "Greatest V2Ray service",
    text: "Greatest V2Ray service I have ever seen, because it fixed almost every data problem of mine. Also tysm Aurex staff. Product 9/10, Customer Service 10/10.",
    country: "LK",
    date: "Oct 22, 2025",
    obsidian: false
  },
  {
    name: "PrimePEX",
    avatar: "https://cdn.aurex.lk/avatars/Yasiru.webp",
    rating: 5,
    title: "W to our one and only AUREX",
    text: "W to our one and only AUREX.",
    country: "LK",
    date: "Oct 23, 2025",
    obsidian: false
  },
  {
    name: "Sinurabro",
    avatar: "https://cdn.aurex.lk/avatars/Hiruni.webp",
    rating: 5,
    title: "Superb customer service",
    text: "Yooooo superb customer service.",
    country: "LK",
    date: "Oct 24, 2025",
    obsidian: false
  },
  {
    name: "TharuuMc",
    avatar: "https://cdn.aurex.lk/avatars/Ravindu.webp",
    rating: 5,
    title: "W server and W owner",
    text: "W server and W owner.",
    country: "LK",
    date: "Oct 24, 2025",
    obsidian: false
  },
  {
    name: "xITZ_ME",
    avatar: "https://cdn.aurex.lk/avatars/Dineth.webp",
    rating: 5,
    title: "Superb hosting",
    text: "Superb hosting.",
    country: "LK",
    date: "Oct 24, 2025",
    obsidian: false
  },
  {
    name: "LAZYBIRD",
    avatar: "https://cdn.aurex.lk/avatars/Tharindu.webp",
    rating: 5,
    title: "Best services as always",
    text: "As always Aurex provides the best services. No lags, no ping issues, great customer service. W Aurex.",
    country: "LK",
    date: "Oct 22, 2025",
    obsidian: true
  },
  {
    name: "DakAPlazy",
    avatar: "https://cdn.aurex.lk/avatars/Tharindu.webp",
    rating: 5,
    title: "Helpful staff",
    text: "Hoda staff ekak. Thank you dena support ekata.",
    country: "LK",
    date: "Nov 5, 2025",
    obsidian: false
  },
  {
    name: "Samadhi Rahal",
    avatar: "https://cdn.aurex.lk/avatars/Kavindu.webp",
    rating: 5,
    title: "Smooth panel",
    text: "Recommended. Panel eka ehmath patta smooth.",
    country: "LK",
    date: "Nov 7, 2025",
    obsidian: false
  },
  {
    name: "SahasesFX",
    avatar: "https://cdn.aurex.lk/avatars/Asel.webp",
    rating: 5,
    title: "100/100 favorite hosting platform",
    text: "100/100 my favorite hosting platform.",
    country: "LK",
    date: "Nov 17, 2025",
    obsidian: false
  },
  {
    name: "Riviya_X",
    avatar: "https://cdn.aurex.lk/avatars/Sachini.webp",
    rating: 5,
    title: "Best budget-friendly hosting",
    text: "I've been using an Aurex server for my project MMU Marks Viewer, and honestly, it's one of the best budget-friendly hosting options I've tried. For LKR 350 per month, the value is insane. Performance is smooth and stable even for Node.js projects, enough resources, clean modern panel, quick support, super affordable. 100% worth it.",
    country: "LK",
    date: "Nov 27, 2025",
    obsidian: false
  },
  {
    name: "MAX PRO",
    avatar: "https://cdn.aurex.lk/avatars/Chamara.webp",
    rating: 5,
    title: "10/10 the best hosting",
    text: "10/10. The best hosting.",
    country: "LK",
    date: "Mar 31, 2026",
    obsidian: false
  }
]

const half = Math.ceil(reviews.length / 2);
const row1 = reviews.slice(0, half);
const row2 = reviews.slice(half);

const StarIcon = () => (
  <div className="bg-[#00b67a] p-[3px]">
    <SiTrustpilot title="Trustpilot Logo" className="text-white" />
  </div>
)

const Card = ({ review }: { review: typeof reviews[0] }) => {
  if (review.obsidian) {
    return (
      <div className="relative flex-shrink-0 w-[350px] h-[180px] flex flex-col gap-3 px-5 py-4">

        <div
          className="absolute inset-0"
          style={{
            backgroundImage: "url('https://cdn.aurex.lk/features-infra.webp')",
            backgroundSize: "100% 100%",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
        <div className="relative flex items-center gap-3">
          <Image src={review.avatar} alt={review.name} width={36} height={36} className="w-9 h-9 rounded-xl flex-shrink-0" />
          <div className="flex flex-col gap-2">
            <span className="text-white font-poppins text-sm font-semibold leading-none">{review.name}</span>
            <div className="flex gap-2">
              {Array.from({ length: review.rating }).map((_, i) => <StarIcon key={i} />)}
            </div>
          </div>
        </div>
        <p className="relative text-white font-poppins text-sm leading-relaxed line-clamp-4 overflow-hidden" title={review.text}>&ldquo;{review.text}&rdquo;</p>
      </div>
    )
  }

  return (
    <div
      className="relative flex-shrink-0 w-[350px] h-[180px] flex flex-col gap-3 rounded-xl px-5 py-4 "
      style={{
        background: "#151124d3",
        border: "1px solid #7c44e513",
      }}
    >
      <div className="flex items-center gap-3">
        <Image src={review.avatar} alt={review.name} width={36} height={36} className="w-9 h-9 rounded-xl flex-shrink-0" style={{ imageRendering: "pixelated" }} />
        <div className="flex flex-col gap-2">
          <span className="text-white font-poppins text-sm font-semibold leading-none">{review.name}</span>
          <div className="flex gap-1">
            {Array.from({ length: review.rating }).map((_, i) => <StarIcon key={i} />)}
          </div>
        </div>
      </div>
      <p className="text-gray-400 font-poppins text-sm leading-relaxed line-clamp-4 overflow-hidden" title={review.text}>&ldquo;{review.text}&rdquo;</p>
    </div>
  )
}

const TRUSTPILOT_RATING = 4.7;
const TRUSTPILOT_REVIEWS = 37;
const TRUSTPILOT_MAX_STARS = 5;

function starFillPercent(slot: number, rating: number): number {
  if (slot <= Math.floor(rating)) return 100;
  if (slot > Math.ceil(rating)) return 0;
  return Math.round((rating % 1) * 100);
}

function TrustpilotWidget({ t }: { t: any }) {
  return (
    <a
      href="https://www.trustpilot.com/review/aurex.lk"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center gap-3 transition-all duration-300 mt-2 group"
    >
      <div className="flex items-center gap-1">
        {Array.from({ length: TRUSTPILOT_MAX_STARS }, (_, i) => {
          const fill = starFillPercent(i + 1, TRUSTPILOT_RATING);
          return (
            <div key={i} className="relative w-7 h-7 bg-gray-400/25 overflow-hidden group-hover:scale-105 transition-transform">
              <div
                className="absolute inset-0 bg-[#00b67a] transition-all"
                style={{ width: `${fill}%` }}
              />
              <span className="absolute inset-0 flex items-center justify-center text-white text-base leading-none select-none">
                <SiTrustpilot title="Trustpilot Star" />
              </span>
            </div>
          );
        })}
      </div>
      <div className="flex flex-col leading-tight text-left">
        <span className="text-sm font-semibold text-white">
          {TRUSTPILOT_RATING.toFixed(1)}{" "}
          <span className="font-normal text-gray-400 text-xs">/ {TRUSTPILOT_MAX_STARS}</span>
        </span>
        <span className="text-[11px] text-gray-400 font-poppins">
          {t('based_on')}{" "}
          <span className="text-white font-medium">{TRUSTPILOT_REVIEWS.toLocaleString()}</span>{" "}
          {t('reviews')}
        </span>
      </div>
      <div className="hidden sm:flex items-center gap-1.5 pl-3 ml-1 border-l border-white/10">
        <SiTrustpilot title="Trustpilot Logo" className="text-[#00b67a] w-6 h-6" />
        <span className="text-md">
          <span className="text-white">Trust</span>
          <span className="text-[#00b67a]">pilot</span>
        </span>
      </div>
    </a>
  );
}

export default function ReviewsSection() {
  const t = useTranslations('Reviews')
  return (
    <section
      className="relative z-10 w-full py-24 bg-black overflow-hidden"
    >
      <div className="mb-12 text-center flex flex-col items-center">
        <div className="relative inline-block">
          <h2 className="text-3xl md:text-4xl font-bold font-akira leading-tight text-white mb-3">{t('title')}</h2>
        </div>
        <p className="text-gray-400 font-poppins text-base max-w-xl mx-auto mb-3">{t('subtitle')}</p>
        <TrustpilotWidget t={t} />
      </div>
      <div
        className="flex flex-col relative"
        style={{ maskImage: "linear-gradient(to right, transparent, black 12%, black 88%, transparent)" }}
      >
        <Marquee className="[--duration:60s]">
          {row1.map((r, i) => <Card key={i} review={r} />)}
        </Marquee>
        <Marquee reverse className="[--duration:60s]">
          {row2.map((r, i) => <Card key={i} review={r} />)}
        </Marquee>
      </div>
    </section>
  )
}


